import { FlexDiv } from "@repo/ui";

import { CalendarTime, CalendarTitle } from "../components/CalendarAppointment";
import { OverflowContainer } from "../components/OverflowContainer";
import { SHORT_SLOT_LENGTH } from "../constants";
import { type CoWorkerCalendarItem } from "../types";

export const TeamCalendarAppointment = ({
  item,
}: {
  item: CoWorkerCalendarItem;
}) => {
  return (
    <OverflowContainer>
      <FlexDiv
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        gap="3px"
      >
        <CalendarTitle item={item} />
        {item.length > SHORT_SLOT_LENGTH && <CalendarTime item={item} />}
      </FlexDiv>
    </OverflowContainer>
  );
};
